<template>
  <div>
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        申请发货单基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请单号：
              </div>
              <div class="rj-baseinfo__item">
                {{ EchoForm.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ EchoForm.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ EchoForm.distributorName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ EchoForm.createTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ EchoForm.createTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ EchoForm.orderSales }}{{ EchoForm.currencyName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                未分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ EchoForm.actualSettlementAmount }}{{ EchoForm.currencyName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ EchoForm.prepaymentRatioNum }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" height="500">
        <el-table-column fixed type="index" width="50" label="序号" align="left" />
        <el-table-column prop="telegraphicTransferNo" label="电汇底单编号" align="left" width="180px" />
        <el-table-column prop="remittanceAmount" label="汇款金额" align="right" header-align="left" width="" />
        <el-table-column prop="remittanceTime" label="汇款日期" align="left" width="180px" />
        <el-table-column prop="importAccount" label="汇入账户" align="left" width="180px" />
        <el-table-column prop="importCompany" label="汇入公司" align="left" width="200px" />
        <el-table-column prop="remark" label="摘要" align="left" width="100px" />
        <el-table-column prop="usedAmount" label="已使用金额" align="right" header-align="left" />
        <el-table-column prop="availableAmount" label="可用余额" align="right" header-align="left" />
        <el-table-column prop="currency" label="币种" align="left" />
        <el-table-column prop="assignAmount" label="本次分配金额" align="left" width="140px">
          <template v-slot="{row}">
            <el-input-number v-model="row.assignAmount" style="width:100%;" :precision="2" :min="0" label="描述文字" @change="assignBlur(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button type="primary" style="margin-top:20px" @click="submitData">
      确认分配
    </el-button>
    <span>
      本次分配金额：<span class="money">{{ assignAllTotal.toFixed(2) }} </span>
    </span>

    <!-- 确认分配弹窗 -->
    <confirmAllocation :info="info" :assign-all-total="assignAllTotal" :dialog-form-visible="dialogFormVisible" :data="sureData" @on-status-dialog="onstatus" />
  </div>
</template>
<script>
import { getContractDetailAllInfoByConNum, listAssignTelegraphicTransferInternationBusiness } from '@/API/index.js';
import { numAdd } from '@/libs/util';
// 导入 弹窗
import confirmAllocation from './confirmAllocation.vue';
export default {
  components: {
    confirmAllocation
  },
  data () {
    return {
      EchoForm: {},
      info: {
        unAssignAll: 0
      },
      dialogFormVisible: false,
      loading: false,
      tableData: [],
      tableLoading: false,
      sureData: {
        dialogData: [],
        contractType: '',
        contractId: 0
      }
    };
  },
  computed: {
    assignAllTotal () {
      let total = 0;
      this.tableData.forEach((item) => {
        total = numAdd(item.assignAmount ? item.assignAmount : 0, total);
      });
      return total;
    }
  },
  methods: {
    initData () {
      let contractNum = this.$route.query.contractNum;
      // 详情
      getContractDetailAllInfoByConNum(contractNum).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.info = data;
          console.log('this.info', this.info);
        }
      });
      // 列表
      listAssignTelegraphicTransferInternationBusiness({ contractNum }).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          data.list.forEach((item) => { item.assignAmount = 0; });
          this.tableData = data.list;
          console.log('this.tabaData', this.tableData);
        }
      });
    },
    onstatus (val) {
      this.dialogFormVisible = val;
      if (!val) {
        this.initData();
      }
    },
    // 提交分配
    submitData () {
    //   this.sureData.dialogData = JSON.parse(JSON.stringify(this.tableData));
    //   this.sureData.dialogData.forEach((item) => {
    //     item.contractNum = this.info.contractNum;
    //     item.actualSettlementAmount = this.info.actualSettlementAmount;
    //   });
    //   // 过滤本次分配金额不为0 的
    //   let resData = this.sureData.dialogData.filter((item) => {
    //     return item.assignAmount > 0;
    //   });
    //   this.sureData.dialogData = resData;
    // 模拟假数据
      this.sureData.dialogData = [
        {
          telegraphicTransferNo: 'FPFH2010190001',
          actualSettlementAmount: 450000.00,
          wiretransferslipnumber: 'G0680200211809C',
          assignAmount: 25600.00
        },
        {
          telegraphicTransferNo: 'FPFH2010191111',
          actualSettlementAmount: 4500.00,
          wiretransferslipnumber: 'G0680200211888C',
          assignAmount: 25601.10
        }
      ];
      this.dialogFormVisible = true;
    },
    // 验证输入金额
    assignBlur (row) {
      console.log(row);
      //  可使用金额   小于  本次分配金额 assignAmount
      if (row.unusedAmount < row.assignAmount) {
        // 本次分配金额就是  可使用金额
        row.assignAmount = row.unusedAmount;
      }
      // 本次分配金额 assignAmount  大于  可用余额
      if (row.assignAmount > row.availableAmount) {
        // 本次分配金额就是  可用余额
        row.assignAmount = row.availableAmount;
      }
      let num = 0;
      this.tableData.forEach((item) => {
        if (item.assignAmount > 0) {
          num = numAdd(num, item.assignAmount);
        }
      });
      if (num > this.info.actualSettlementAmount) {
        this.$message.warning('本次分配金额大于未分配金额，请进行调整');
        row.assignAmount = 0;
      }
    }
  },
  mounted () {
    this.initData();
    console.log(this.$route.query.row.contractNum);
    this.EchoForm = this.$route.query.row;
  }
};
</script>
<style lang="scss" scoped>
</style>
